import { makeAutoObservable } from "mobx";
import { IFollowUpQuestion } from "../../../models/ReturnReasonTypes";
import { FOLLOW_UP_QUESTION_TYPE } from "../../return-reasons/constants";
import CreateRmaFuqAnswerStore from "./create-rma-fuq-answer-store";
import { ICRmaFollowUpQuestionRequestDto } from "./request-product-store";


class CreateRmaFuqStore {
    private _answers: CreateRmaFuqAnswerStore[] = [];
    private _translation: string = '';

    constructor(private _model: IFollowUpQuestion) {
        makeAutoObservable(this, {}, {autoBind: true});
        this._setAnswerStores() ;
    }
    
    get id():number {return this._model.id;}
    get translationKey():string {return this._model.question;}
    get type():FOLLOW_UP_QUESTION_TYPE {return this._model.type;}
    get answers():CreateRmaFuqAnswerStore[] {return this._answers;}
    get isAnswered():boolean {
        /** Currently we don't support media upload for C-RMA FUQs, therefor we don't check for its answers and just return true.*/
        return this.type === FOLLOW_UP_QUESTION_TYPE.ImageRequest || !!this._answers.some((answer) => {
           if ([FOLLOW_UP_QUESTION_TYPE.FreeText, FOLLOW_UP_QUESTION_TYPE.NumericStepper].includes(this._model.type)) {
               return !!answer.answer && answer.answer.length > 0;
           }
           return answer.isSelected;
       }); 
    }
    get stepperMaxValue(): number|undefined { return this._model.stepper_max_value; }
    get stepperMinValue(): number|undefined { return this._model.stepper_min_value; }
    get isImageRequested(): boolean { return this._model.is_image_requested ?? false; }
    get imageInstruction(): string { return this._model.image_instruction ?? ''; }
    get weight(): number { return this._model.weight; }

    private _setAnswerStores() {
        if (this._model.merchant_return_reason_fuq_answers.length === 0) {
            let defaultAnswer;
            if (this._model.type === FOLLOW_UP_QUESTION_TYPE.NumericStepper) {
                defaultAnswer = this._model.stepper_default_value?.toString();
            }

            this._answers = [new CreateRmaFuqAnswerStore(undefined, true, defaultAnswer)];
            return;
        }
        this._answers = this._model.merchant_return_reason_fuq_answers.map(answer =>  new CreateRmaFuqAnswerStore(answer)).sort((a1,a2) => (a1.weight > a2.weight) ? 1 : -1);

    }

    public resetAllAnswersSelections() {
        this.answers.forEach((answer) => answer.setIsSelected(false));
    }

    public setSelectedAnswer(answer: CreateRmaFuqAnswerStore, getTranslation: (k: string) => string) {
        answer.setIsSelected(true, getTranslation);
    }

    public setQuestionTranslation(translation: string) {
        this._translation = translation;
    }

    public requestModel(): ICRmaFollowUpQuestionRequestDto {
        return {
            return_reasons_fuq_id: this._model.id,
            translation_key: this._model.question,
            translation: this._translation,
            answers: this.getSelectedAnswers().map(answer => answer.requestModel()),
        }
    };

    private getSelectedAnswers() {
        return this._answers.filter(answer => answer.isSelected) ?? [];
    }

}

export default CreateRmaFuqStore; 